import { useEffect } from "react"
import { useSignal } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { customerSelectedID, isSystemBusy } from "@signals"
import { PRICING_CONFIG_APIS, PRICING_CONFIG_MODES } from "../@constants"
import {
    isConfigEmpty,
    mainSitesData,
    pricingConfigMode,
    reloadPricingConfigData,
    rrspData
} from "../@signals"


/** Current configuration of the selected customer, for the active branch only.
 *
 * Fires on **customer change and on mode change**, with no Search in between: picking the customer
 * is the whole input of this form (there is no submit button, see `Filters.jsx`).
 *
 * Only the active branch is fetched: the RRSP list is bounded by the customer's whole catalogue
 * (13.613 SKUs for the largest one), so loading it to show the retailer tab would be a big query
 * nobody asked for.
 */
export default function usePricingConfigData() {

    const isLoading = useSignal(false)

    const loadBranch = () => {
        const customerID = customerSelectedID.value
        if (!customerID) return

        const isRrsp = pricingConfigMode.value === PRICING_CONFIG_MODES.RRSP
        const url = isRrsp ? PRICING_CONFIG_APIS.RRSP : PRICING_CONFIG_APIS.MAIN_SITES
        const target = isRrsp ? rrspData : mainSitesData

        isLoading.value = true
        postSubmit(url, { customerID })
            .then(res => {
                target.value = res ?? []
                isConfigEmpty.value = false
                isLoading.value = false
            })
            .catch(() => {
                isLoading.value = false
                isSystemBusy.value = true
            })
    }

    useEffect(() => {
        loadBranch()
    }, [pricingConfigMode.value, customerSelectedID.value])

    useEffect(() => {
        if (reloadPricingConfigData.value) {
            loadBranch()
            reloadPricingConfigData.value = false
        }
    }, [reloadPricingConfigData.value])

    return {
        isLoading: isLoading.value
    }
}
